import styled, { css } from 'styled-components';
import {
  fontWeight,
  themeColor,
  transparentizeColor,
  multiply,
  fontSize,
  lineHeight,
  mediaBreakpointUp,
  mediaBreakpointDown,
  borderRadius,
  getThemeProp,
  gray,
  zIndex,
  getLeftValue,
} from '@whitelabel/helpers/style';

interface IStyledSingleDatePickerInputProps {
  readonly $focused: boolean;
  readonly $invalid: boolean;
  $rtl: boolean;
  $hasSingleDateQuestion?: boolean;
}

export const StyledSingleDatePickerInput = styled.div<IStyledSingleDatePickerInputProps>`
  .DateInput_input {
    padding: 0.5rem 0.75rem 0.5rem 0.5rem;
    font-weight: ${fontWeight('normal')};
    font-size: ${multiply(fontSize('base'), 1.125)};
    line-height: ${lineHeight('base')};
    text-transform: uppercase;
    border-bottom: none;
    cursor: pointer;

    ${mediaBreakpointUp('md')`
      padding-inline-end: 1rem;
    `}
    ${mediaBreakpointUp('lg')`
      font-size: ${fontSize('lg')};
    `}
  }
  .DateInput_input__focused {
    border-bottom: none;
  }
  .CalendarDay__default {
    &:hover {
      background: ${transparentizeColor(0.5, themeColor('primary'))};
    }
  }
  .CalendarDay__selected {
    color: ${themeColor('header')};
    font-weight: ${fontWeight('bold')};
    background: ${themeColor('primary')};
    border: 0;
    &:hover {
      background: ${themeColor('primary')};
    }
  }
  .SingleDatePickerInput {
    display: flex;
    border: ${getThemeProp('borderWidth')} solid
      ${({ $focused, $invalid }) => {
        if ($invalid) {
          return themeColor('danger');
        }
        if ($focused) {
          return gray(700);
        }
        return gray(500);
      }};
    border-radius: ${borderRadius('base')};

    &:hover {
      border: ${getThemeProp('borderWidth')} solid ${gray(700)};
    }
  }

  .SingleDatePicker {
    height: 2.6875rem;

    ${mediaBreakpointUp('lg')`
      height: 2.875rem;
    `}
  }
  .SingleDatePickerInput_calendarIcon {
    display: flex;
    align-items: center;
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;
    padding-inline-start: 0.75rem;
    padding-inline-end: 0;

    ${mediaBreakpointUp('md')`
      padding-top: 0;
      padding-bottom: 0;
      padding-inline-start: 1rem;
      padding-inline-end: 0;
    `}
  }
  .SingleDatePickerInput_calendarIcon_svg {
    width: 1rem;
    height: 1rem;
  }
  .DateInput {
    width: 9.25rem;
  }
  .SingleDatePicker_picker {
    z-index: ${zIndex('contentLayer')};
    ${getLeftValue('0')}
    ${({ $hasSingleDateQuestion, $rtl }) =>
      $hasSingleDateQuestion &&
      css`
        ${mediaBreakpointDown('xs')`
          ${$rtl ? 'right' : 'left'}: -4.35rem !important;
        `}
      `}
  }
  .DateInput_fang {
    ${getLeftValue('22px')}
    ${({ $hasSingleDateQuestion }) =>
      $hasSingleDateQuestion &&
      css`
        ${mediaBreakpointDown('xs')`
          ${getLeftValue('3.25rem')}
        `}
      `}
  }
`;
